import { Component } from '@angular/core';
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: 'app-email-verified',
  templateUrl: './email-verified.component.html',
  styleUrls: ['./email-verified.component.scss']
})
export class EmailVerifiedComponent {
  constructor(public authService: AuthService) {
    
  }
}


